import { NavLink, Outlet } from "react-router-dom";
import { useStateContext } from "../../Contexts/ContextProvider";

export default function Account () {
  const { user } = useStateContext();

    return (
    <div className="container-fluid px-2 px-md-4">
      <div className="card card-body mx-3 mx-md-4">
        <div className="row gx-4 align-items-center mb-3">
          <div className="col-md">
            <h5 className="mb-1">Account</h5>
            <p className="text-sm text-secondary mb-0">
              Manage your profile and security settings{user?.first_name ? `, ${user.first_name}` : ""}.
            </p>
          </div>
          <div className="col-md-auto mt-3 mt-md-0">
            <div className="nav-wrapper">
              <ul className="nav nav-pills p-1" role="tablist" aria-label="Account sections">
                <li className="nav-item">
                  <NavLink to="/Account/View" className={({ isActive }) => `nav-link mb-0 px-3 py-2 ${isActive ? "active" : ""}`}>
                    <i className="material-icons text-lg align-middle">person</i>
                    <span className="ms-1">Profile</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/Account/Settings" className={({ isActive }) => `nav-link mb-0 px-3 py-2 ${isActive ? "active" : ""}`}>
                    <i className="material-icons text-lg align-middle">settings</i>
                    <span className="ms-1">Settings</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="horizontal dark my-2" />
        <div className="row">
          <Outlet />
        </div>
      </div>
    </div>
    )
}